window.toggleRegPass = toggleRegPass;
window.startResendCountdown = startResendCountdown;

function toggleRegPass() {
    var passInput = document.getElementById('reg-password');
    var eyeIcon = document.getElementById('regEyeIcon');
    if (passInput.type === 'password') {
        passInput.type = 'text';
        eyeIcon.classList.replace('fa-eye', 'fa-eye-slash');
    } else {
        passInput.type = 'password';
        eyeIcon.classList.replace('fa-eye-slash', 'fa-eye');
    }
}

function startResendCountdown() {
    var totalSeconds = 300;
    var countdownEl = document.getElementById('resend-countdown');
    var secondsEl = document.getElementById('resend-seconds');
    var linkEl = document.getElementById('resend-link');

    if (!countdownEl || !secondsEl || !linkEl) return;

    countdownEl.style.display = '';
    linkEl.style.display = 'none';

    function formatTime(s) {
        var m = Math.floor(s / 60);
        var sec = s % 60;
        return m + ':' + (sec < 10 ? '0' : '') + sec;
    }

    secondsEl.textContent = formatTime(totalSeconds);

    var timer = setInterval(function () {
        totalSeconds--;
        secondsEl.textContent = formatTime(totalSeconds);
        if (totalSeconds <= 0) {
            clearInterval(timer);
            countdownEl.style.display = 'none';
            linkEl.style.display = '';
        }
    }, 1000);
}

document.addEventListener('livewire:load', function () {
    startResendCountdown();

    Livewire.hook('message.processed', function () {
        if (document.getElementById('resend-countdown')) {
            startResendCountdown();
        }
    });
});
